module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch",
    class: [
      _vm.showTag ? 'switch-tag' : '',
      _vm.cssState
    ],
    on: {
      "click": _vm._handleClick
    }
  }, [(_vm.showTag) ? _c('span', {
    staticClass: "on"
  }, [_vm._v(_vm._s(_vm.tag[0]))]) : _vm._e(), _vm._v(" "), (_vm.showTag) ? _c('span', {
    staticClass: "off"
  }, [_vm._v(_vm._s(_vm.tag[1]))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0435c042!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bo-switch/bo-switch.vue
// module id = 18
// module chunks = 9 10 18 30